<template>
  <div>
    <div id="showcase">
      <v-layout row wrap>
        <v-flex xs12 lg4 offset-lg1>
          <div class="box sidebar text-xs-center">
            <div class="logo ">
              <img src="../assets/kristenlogo.png" alt="">
              <img src="../assets/mortgagebrokers.jpg" alt="">

            </div>
            <br>
            <div v-if="!success">
              <h1>Free Pre-Approval</h1>
              <h3>Please fill out the form below and I will contact you shortly.</h3>
              <v-form v-model="valid" ref="contact-form">
                <v-text-field class=""
                  dark
                  color="deep-orange lighten-1"
                  v-model="name"
                  :rules="nameRules"
                  label="Name"
                  required></v-text-field>
                <v-text-field
                  required
                  validate-on-blur
                  :rules="emailRules"
                  dark
                  color="deep-orange lighten-1"
                  v-model="email"
                  label="Email"></v-text-field>
                <v-text-field
                  mask="phone"
                  required
                  validate-on-blur
                  :rules="phoneRules"
                  dark
                  color="deep-orange lighten-1"
                  v-model="phone"
                  label="Phone Number"></v-text-field>
                <v-text-field
                  validate-on-blur
                  :rules="validationRules"
                  dark
                  color="deep-orange lighten-1"
                  v-model="validation"
                  :label="'Are you a human? What is ' + formNumberOne + ' + ' + formNumberTwo + ' = ? '"></v-text-field>
                <v-layout row wrap>
                  <v-flex xs4>
                    <v-checkbox
                      label="Phone"
                      color="deep-orange lighten-1"
                      v-model="preferredContact"
                      value="phone"
                      dark></v-checkbox>
                  </v-flex>
                  <v-flex xs4>
                    <v-checkbox
                      label="Text"
                      color="deep-orange lighten-1"
                      v-model="preferredContact"
                      value="text"
                      dark></v-checkbox>
                  </v-flex>
                  <v-flex xs4>
                    <v-checkbox
                      color="deep-orange lighten-1"
                      label="Email"
                      v-model="preferredContact"
                      value="email"
                      dark></v-checkbox>
                  </v-flex>
                </v-layout>
                <v-btn dark block color="deep-orange lighten-1" @click="onSubmit" :disabled="!valid">Submit</v-btn>
              </v-form>
              <v-divider dark></v-divider>
              <br>
            </div>
            <div v-else>
              <v-divider dark></v-divider>
              <br>
              <h1>Thank you. I'll {{ preferredContact }} you soon!</h1>
              <br>
              <v-divider dark></v-divider>
              <br>
            </div>

            <v-layout row wrap>
              <v-flex xs12 sm6>
                <div class="text-xs-left">
                  <h3>Kristen Evans</h3>
                  <h4>MBA, Associate Lending Manager</h4>
                  <h4>NMLS #289464</h4>
                  <h4>kristen@kristenevans.net</h4>
                  <h4>801.913.7367</h4>
                </div>
              </v-flex>
              <v-flex xs12 sm6>
                <div class="text-xs-left">
                  <h3>Mortgage Brokers, LLC</h3>
                  <h4>NMLS #1157639</h4>
                  <h4>4252 S Highland Drive suite 104</h4>
                  <h4>Salt Lake City, UT 84124 </h4>
                </div>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs12 sm4>
          <div class="box greeting text-xs-center hidden-md-and-down">
            <h1>Professional... Affordable... Local</h1>
            <br>
            <h3>Talk to a real person not a computer</h3>
            <br>
            <h4 class="text-xs-left">With over a decade doing loans in the Utah market, I know what it takes to get you the best loan. I've saved my clients millions over the life of their loans and have made friendships that will last forever. Contact me today to see what I can do for you.</h4>
          </div>
        </v-flex>
        <v-spacer></v-spacer>
        <!--<v-flex xs12 class="ma-4 box hidden-sm-and-down">-->
          <!--Disclaimer: Absolute Home Mortgage Corporation NMLS #176743, Connecticut Mortgage Lender License #ML-176743, District of Columbia Mortgage Dual Authority License#MLB176743, Florida Office of Financial Regulation License #MLD424, Maryland Division of Financial Regulation License #06-19958, Licensed by the New Jersey Department of Banking and Insurance, License #9826392, New York Mortgage Broker Registration # A005639, Licensed under Ohio Mortgage Broker Act Certificate of Registration # MB.804122.000 and the Ohio Mortgage Loan Certificate of Registration # SM.501845.000, Licensed by the Pennsylvania Department of Banking, License #34628 Equal Housing Lender. Licensed by the Department of Business Oversight under the California Financial Lender Law Mortgage Bankers License #603L578.-->
        <!--</v-flex>-->
      </v-layout>
    </div>
  </div>

</template>

<script>
  import * as firebase from 'firebase'
//  import axios from 'axios'
  /* eslint no-useless-escape: "off" */

export default {
    name: 'home',
    data () {
      return {
        preferredContact: 'phone',
        name: '',
        nameRules: [
          (v) => !!v || 'Name is required',
          (v) => v && v.length <= 20 || 'Name must be less than 20 characters'
        ],
        email: '',
        emailRules: [
          (v) => !!v || 'E-mail is required',
          (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        ],
        phone: '',
        phoneRules: [
          (v) => !!v || 'Phone number is required'
        ],
        error: '',
        valid: false,
        validation: '',
        validationRules: [
          (v) => !!v || 'Are you a robot?',
          (v) => Number(this.validation) === this.formNumberOne + this.formNumberTwo || 'Please enter sum of the two numbers'
        ],
        success: false
      }
    },
    computed: {
      formNumberOne () {
        return Math.floor(Math.random() * 100)
      },
      formNumberTwo () {
        return Math.floor(Math.random() * 100)
      },
      formSolution () {
        if (Number(this.validation) === this.formNumberOne + this.formNumberTwo) {
          return true
        } else {
          return false
        }
      }
    },
    methods: {
      onSubmit () {
        let submission = {
          name: this.name,
          email: this.email,
          phone: this.phone,
          contact: this.preferredContact
        }
        firebase.database().ref('contact-form').push(submission)
        this.success = true
      }
    }
}
</script>


<style scoped>

  #showcase{
    background-image: url('/static/kristenandboys.jpg');
    background-size: cover;
    background-position: right;
    height: 100vh;
    display: flex;
    flex-direction: column;
    /*justify-content: center;*/
  }
  .logo{
    background-color: white;
    border-radius: 3px;
  }
  .logo img{
    width: 90%;
  }
  .greeting{
    margin-top: 30px;
    /*height: 20vh;*/
    padding: 10px;
  }
  .greeting h2{
    line-height: 1;
  }
  .sidebar{
    /*height: 100vh;*/
    padding: 20px;
    margin: 20px;
  }
  .box{
    color: white;
    border-radius: 2px;
    background-color: rgba(0,0,0,0.60)
  }

  .shadow {
    -webkit-box-shadow: 3px 3px 5px 6px #ccc;  /* Safari 3-4, iOS 4.0.2 - 4.2, Android 2.3+ */
    -moz-box-shadow:    3px 3px 5px 6px #ccc;  /* Firefox 3.5 - 3.6 */
    box-shadow:         3px 3px 5px 6px #ccc;  /* Opera 10.5, IE 9, Firefox 4+, Chrome 6+, iOS 5 */
  }

</style>



// WEBPACK FOOTER //
// src/components/Home.vue